/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TagsIcon extends BaseIcon {
  getChildren = () => [ <path d="M10.67,2,3.77,8.75,9.1,14,16,7.21V2ZM12.5,7A1.5,1.5,0,1,1,14,5.5,1.5,1.5,0,0,1,12.5,7Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
